module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/poster-boom-share-e97c4a6095716a80f31f728640063e1c.png";